import AccountService from "./implementations/account.service";

export default defineNuxtPlugin((nuxtApp) => {
  const account = new AccountService();

  return {
    provide: {
        account: account,
    },
  };
});